import defaultSortComparator from './DefaultSortComparator';
import { getDisplayZone } from 'common/types/GetDisplayZone';

/*
 * Used as the column comparator for zone columns (LoadZ, DischZ).
 * When the user explicitly sorts by a zone column, rows are ordered
 * alphabetically by their displayed value, so the sort order always
 * matches what is visible on screen — including when a zone mapping is active.
 *
 * The hardcoded priority-list ordering is preserved for the default (no user
 * sort) arrangement, which is handled separately in columnsPostSort.
 */
const ZoneComparator = (valueA, valueB, nodeA, nodeB, field = 'loadZone') => {
    if (nodeA.group) {
        return defaultSortComparator(valueA, valueB);
    }

    const zonesA = Array.isArray(valueA)
        ? valueA.map((x) => getDisplayZone(x, field))
        : valueA
        ? [getDisplayZone(valueA, field)]
        : [];
    const zonesB = Array.isArray(valueB)
        ? valueB.map((x) => getDisplayZone(x, field))
        : valueB
        ? [getDisplayZone(valueB, field)]
        : [];

    const len = Math.max(zonesA.length, zonesB.length);
    for (let i = 0; i < len; i++) {
        if (i >= zonesA.length) return -1;
        if (i >= zonesB.length) return 1;
        const result = defaultSortComparator(zonesA[i], zonesB[i]);
        if (result !== 0) return result;
    }
    return 0;
};

export default ZoneComparator;
